import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { ExperiencesService } from '../../experiences/experiences.service';
import { Interaction } from '../interaction.model';
import { InteractionsService } from '../interactions.service';

@Component({
  selector: 'app-edit-interaction',
  templateUrl: './edit-interaction.component.html',
  styleUrls: ['./edit-interaction.component.scss']
})
export class EditInteractionComponent implements OnInit {

  interaction: Interaction;
  expPath: any[];
  intId: number;
  intOrder: number;
  tempExpId: number;

  constructor(
    private intService: InteractionsService,
    private activatedRoute: ActivatedRoute,
    private toastyService: ToastyService,
    private router: Router,
    private expService: ExperiencesService
  ) { }

  ngOnInit(): void {

    if (this.activatedRoute.snapshot.queryParams.expPath) {
      this.expPath = this.activatedRoute.snapshot.queryParams.expPath.split('/');
      this.intOrder = + this.activatedRoute.snapshot.queryParams.order;
      this.tempExpId = + this.activatedRoute.snapshot.queryParams.tempExpId;
    }

    this.intId = this.activatedRoute.snapshot.params.id;
    this.intService.getOneInteraction(+this.intId).subscribe((res: {data: Interaction, message: string}) => {
      this.interaction = res.data;
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  updateInteraction(interaction: Interaction): void {
    this.intService.editInteraction(interaction)
    .subscribe(res => {
      this.toastyService.success({
        title: 'Interaction aggiornata',
        msg: 'La tua Interaction "<b>' + interaction.title + '</b>" è stata aggiornata correttamente.'
      });
      if (this.expPath) {
        console.log('res', res);
        const intId = + res.data.id;
        const groupId = + this.expPath[this.expPath.length -1];
        this.router.navigate(this.expPath);
      } else {
        this.router.navigate(['/interactions']);
      }
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

}
